import { EmptyMarketplaceProvider } from './empty-marketplace-provider';
import { MarketplaceProvider } from './interfaces';

export class MarketplaceCreator {
    /**
     * Set the customMarketplaceProvider as the singleton marketplaceProvider.
     * @param {MarketplaceProvider} customMarketplaceProvider - User specified marketplace marketplaceProvider
     */
    public static setProvider(customMarketplaceProvider: MarketplaceProvider): void {
        MarketplaceCreator.marketplaceProvider = customMarketplaceProvider;
    }

    /**
     * Create singleton Marketplace marketplaceProvider which creates marketplace configuration.
     * Return the singleton marketplaceProvider if it exists.
     * Otherwise, set an EmptyMarketplaceProvider object as singleton marketplaceProvider and return it.
     * @return {MarketplaceProvider} the singleton MarketplaceProvider marketplaceProvider
     */
    public static provider(): MarketplaceProvider {
        if (!MarketplaceCreator.marketplaceProvider) {
            MarketplaceCreator.marketplaceProvider = new EmptyMarketplaceProvider();
        }
        return MarketplaceCreator.marketplaceProvider;
    }

    private static marketplaceProvider: MarketplaceProvider | undefined = undefined;
}
